//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { XHeader,Flexbox, FlexboxItem }from 'vux'
import CellBox from "../../node_modules/vux/src/components/cell-box/index";

export default {
  components: {
    CellBox,
    XHeader,
    Flexbox,
    FlexboxItem
  },
  data () {
    return {
      headerBackStatus: true,//页首返回按钮是否显示，推送跳入时使用
      pageTitle: '',
      userName: false,
      itemId:'',
      article:{
        title:'',
        staffName:'',
        readTimes:0,
        jian:'',
        context:'',
        fileName:''
      },
      imageSrc:this.$store.state.url,
      image:'',
      wxFilePath:'',//附件地址
      baseUrl: this.$store.state.url,
    }
  },
  mounted () {
    this.itemId=this.$route.query.id.id;
    if(this.itemId==undefined){
      this.itemId=window.localStorage.getItem('articleId');
    }
      if(this.$route.query.isJump){//点击推送，跳入详情页
          console.log('跳转',this.$route.query);
          this.headerBackStatus = false;//替换返回按钮
          this.baseUrl = this.$route.query.hostAddress;
          this.itemId=this.$route.query.id;
          this.$store.commit('setStateVal',{
              url: this.baseUrl,
              token: this.$route.query.token,
              userName: this.$route.query.account,
          });
      }
    if(this.$store.state.userInfo.accounts){
      this.userName = this.$store.state.userInfo.accounts;
    }
    //获取新闻详情
    this.axios({
      url: this.$store.state.url+'/wechat/information/viewInformation/'+this.itemId,
      method: 'get',
    }).then((response) => {
      this.article=response.data.obj;
      this.image=response.data.photoPath;
      this.imageSrc=this.imageSrc+'/'+response.data.photoPath;
    }).catch((response) => {

    });
  },
  methods: {
    goLogin () {
      this.$router.push({ name: 'Login'});
    },
      goTodo () {
      this.$router.push({ name: 'Notice'});
      },
    //获取附件地址
    getFilePath(){
      this.$vux.loading.show({
        text: '加载中'
      });
      window.localStorage.setItem('articleId',this.itemId);
      this.axios({
        url: this.$store.state.url+'/wechat/information/viewFile/'+this.article.id,
        method: 'get',
      }).then((response) => {
        this.$vux.loading.hide();
        this.wxFilePath=response.data.wxFilePath;
        let typeStr = this.wxFilePath.toLowerCase().slice(-3);
        if(typeStr==='jpg'||typeStr==='png'||typeStr==='gif'||typeStr==='peg'){// 图片
          let picUrl = this.baseUrl + '/' +this.wxFilePath;
          let showImgArr = [];
          showImgArr.push(picUrl);
          setTimeout(() => {
            wx.previewImage({
              current: picUrl, // 当前显示图片的http链接
              urls: showImgArr // 需要预览的图片http链接列表
            });
          }, 500);
        }else{
          this.$router.push({
            path: '/seefile',
            query:{
              loadFile:this.baseUrl + '/'+this.wxFilePath,
              fileName:this.article.fileName
            }
          });
        }

      }).catch((response) => {

      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/page/Content.vue